<template>
  <v-container class="pb-10">
    <h1 class="mb-4">Transaction History</h1>
    <v-row>
      <v-col class="" cols="12" md="9">
        <v-select
          outlined
          :items="tabList"
          item-text="title"
          item-value="index"
          v-model="transactionTab"
        ></v-select>
        <v-tabs
          color="accent"
          v-model="transactionTab"
          :vertical="$vuetify.breakpoint.smAndDown"
          grow
          :center-active="!$vuetify.breakpoint.smAndDown"
          show-arrows
          class="custom-tab"
        >
          <v-tab>Sales</v-tab>
          <v-tab v-if="userCountry !== 'Ghana' || userCountry !== 'Kenya'"
            >Purchase
          </v-tab>
          <v-tab>Giftcard</v-tab>
          <v-tab>Cashback</v-tab>
          <v-tab>Fund Transfer</v-tab>
          <v-tab>Token Conversion History</v-tab>
          <v-tab>Bonus Conversion History</v-tab>
          <v-tab>Promo Codes Usage</v-tab>
          <v-tab>Bill History</v-tab>
          <v-tab v-if="userCountry !== 'Ghana' || userCountry !== 'Kenya'"
            >Funding History
          </v-tab>
          <v-tab>Withdrawals</v-tab>
          <v-tab>Swap History</v-tab>
        </v-tabs>
        <v-tabs-items v-model="transactionTab">
          <!--          Sales-->
          <v-tab-item>
            <v-card flat :loading="salesLoading">
              <v-container class="py-10">
                <v-col
                  v-if="!salesLoading && transactionSales.length === 0"
                  class="text-center"
                >
                  <no-transaction />
                  <v-btn
                    depressed
                    class="accent darken-1 mx-auto"
                    to="/user/products"
                    >Start Transaction
                  </v-btn>
                </v-col>
                <v-data-table
                  v-else
                  :headers="headers"
                  :items="transactionSales"
                  :loading="salesLoading"
                  :server-items-length="salesTotal"
                  :items-per-page="salesPerPage"
                  :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
                  disable-sort
                  class="elevation-0"
                  show-expand
                  :single-expand="true"
                  @update:page="onSalesPageChange"
                  @update:items-per-page="onSalesPerPageChange"
                >
                  <template v-slot:[`item.trx`]="{ item }">
                    <span :title="item.trx" class="truncate">{{
                      truncate(item.trx, 10)
                    }}</span>
                  </template>
                  <template v-slot:[`item.rate`]="{ item }">
                    <span>{{ item.rate.price }}</span>
                    <span class="overline"> {{ item.rate.currency }}</span>
                  </template>
                  <template v-slot:[`item.amount`]="{ item }">
                    <span>{{ item.amount.price }}</span>
                    <span class="overline"> {{ item.amount.currency }}</span>
                  </template>
                  <template v-slot:[`item.price`]="{ item }">
                    <span>{{ item.price }}</span>
                    <span class="overline"> {{ currency }}</span>
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    <v-card
                      :color="
                        item.status == 'approved'
                          ? 'success'
                          : item.status == 'pending' ||
                            item.status == 'processing'
                          ? 'warning'
                          : 'error'
                      "
                      flat
                      rounded="md"
                      outlined
                      class="text-capitalize text-center white--text pa-1"
                    >
                      {{ item.status }}
                    </v-card>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <div>
                        <v-row>
                          <v-col>
                            <div class="d-flex py-4">
                              <h2 class="mr-2">{{ item.price }}</h2>
                              <span class="overline"> {{ currency }}</span>
                            </div>
                            <div v-if="item.status === 'declined'">
                              <p>
                                {{ item.reason }}
                              </p>
                              <div
                                v-if="Array.isArray(item.declineImages)"
                                class="d-flex"
                              >
                                <CoolLightBox
                                  :items="item.declineImages"
                                  :index="salesImageIndex"
                                  @close="salesImageIndex = null"
                                >
                                  <template v-slot:close>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke-width="1.5"
                                      stroke="currentColor"
                                      class="w-6 h-6"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M6 18L18 6M6 6l12 12"
                                      />
                                    </svg>
                                  </template>
                                </CoolLightBox>
                                <div style="display: flex">
                                  <div
                                    style="
                                      width: 50px;
                                      height: 50px;
                                      margin-right: 10px;
                                      background-size: cover;
                                    "
                                    v-for="(
                                      image, imageIndex
                                    ) in item.declineImages"
                                    :key="imageIndex"
                                    @click="salesImageIndex = imageIndex"
                                    :style="{
                                      backgroundImage: 'url(' + image + ')'
                                    }"
                                  ></div>
                                </div>
                              </div>
                              <div v-else>
                                <v-img
                                  :src="item.declineImages"
                                  width="80"
                                  height="80"
                                ></v-img>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </template>
                </v-data-table>
              </v-container>
            </v-card>
          </v-tab-item>
          <!-- Purchase -->
          <v-tab-item
            v-if="COUNTRIES.GH !== userCountry || COUNTRIES.KE !== userCountry"
          >
            <v-card flat :loading="purchaseLoading">
              <v-container class="py-2">
                <v-col
                  v-if="!purchaseLoading && transactionPurchase.length === 0"
                  class="text-center"
                >
                  <no-transaction />
                  <v-btn
                    depressed
                    class="accent darken-1 mx-auto"
                    to="/user/products"
                    >Start Transaction
                  </v-btn>
                </v-col>
                <v-data-table
                  v-else
                  :headers="headers"
                  :items="transactionPurchase"
                  :loading="purchaseLoading"
                  :server-items-length="purchaseTotal"
                  :items-per-page="purchasePerPage"
                  :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
                  disable-sort
                  class="elevation-0"
                  show-expand
                  :single-expand="true"
                  @update:page="onPurchasePageChange"
                  @update:items-per-page="onPurchasePerPageChange"
                >
                  <template v-slot:[`item.trx`]="{ item }">
                    <span :title="item.trx" class="truncate">{{
                      truncate(item.trx, 10)
                    }}</span>
                  </template>
                  <template v-slot:[`item.rate`]="{ item }">
                    <span>{{ item.rate.price }}</span>
                    <span class="overline"> {{ item.rate.currency }}</span>
                  </template>
                  <template v-slot:[`item.amount`]="{ item }">
                    <span>{{ item.amount.price }}</span>
                    <span class="overline"> {{ item.amount.currency }}</span>
                  </template>
                  <template v-slot:[`item.price`]="{ item }">
                    <span>{{ item.price }}</span>
                    <span class="overline"> {{ currency }}</span>
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    <v-card
                      :color="
                        item.status == 'approved'
                          ? 'success'
                          : item.status == 'pending' ||
                            item.status == 'processing'
                          ? 'warning'
                          : 'error'
                      "
                      flat
                      rounded="md"
                      outlined
                      class="text-capitalize text-center white--text pa-1"
                    >
                      {{ item.status }}
                    </v-card>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <div>
                        <v-row>
                          <v-col>
                            <div class="d-flex py-4">
                              <h2 class="mr-2">{{ item.price }}</h2>
                              <span class="overline"> {{ currency }}</span>
                            </div>
                            <div v-if="item.status === 'declined'">
                              <p>{{ item.reason }}</p>
                              <div
                                v-if="Array.isArray(item.declineImages)"
                                class="d-flex"
                              >
                                <CoolLightBox
                                  :items="item.declineImages"
                                  :index="purchaseImageIndex"
                                  @close="purchaseImageIndex = null"
                                >
                                  <template v-slot:close>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke-width="1.5"
                                      stroke="currentColor"
                                      class="w-6 h-6"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M6 18L18 6M6 6l12 12"
                                      />
                                    </svg>
                                  </template>
                                </CoolLightBox>
                                <div style="display: flex">
                                  <div
                                    style="
                                      width: 50px;
                                      height: 50px;
                                      margin-right: 10px;
                                      background-size: cover;
                                    "
                                    v-for="(
                                      image, imageIndex
                                    ) in item.declineImages"
                                    :key="imageIndex"
                                    @click="purchaseImageIndex = imageIndex"
                                    :style="{
                                      backgroundImage: 'url(' + image + ')'
                                    }"
                                  ></div>
                                </div>
                              </div>
                              <div v-else>
                                <v-img
                                  :src="item.declineImages"
                                  width="80"
                                  height="80"
                                ></v-img>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </template>
                </v-data-table>
              </v-container>
            </v-card>
          </v-tab-item>

          <!--          Gittcard-->
          <v-tab-item>
            <v-card flat :loading="giftcardLoading">
              <v-container class="py-2">
                <v-col
                  v-if="!giftcardLoading && transactionGiftcard.length === 0"
                  class="text-center"
                >
                  <no-transaction />
                  <v-btn
                    depressed
                    class="accent darken-1 mx-auto"
                    to="/user/products"
                    >Start Transaction
                  </v-btn>
                </v-col>
                <v-data-table
                  v-else
                  :headers="giftcardHeaders"
                  :items="transactionGiftcard"
                  :loading="giftcardLoading"
                  :server-items-length="giftcardTotal"
                  :items-per-page="giftcardPerPage"
                  :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
                  disable-sort
                  class="elevation-0"
                  show-expand
                  :single-expand="true"
                  @update:page="onGiftcardPageChange"
                  @update:items-per-page="onGiftcardPerPageChange"
                >
                  <template v-slot:[`item.image`]="{ item }">
                    <v-img :src="item.image" width="45"></v-img>
                  </template>
                  <template v-slot:[`item.amount`]="{ item }">
                    <span>{{ item.amount }}</span>
                    <span class="overline"> {{ currency }}</span>
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    <v-card
                      :color="
                        item.status == 'approved'
                          ? 'success'
                          : item.status == 'pending' ||
                            item.status == 'processing'
                          ? 'warning'
                          : 'error'
                      "
                      flat
                      rounded="md"
                      outlined
                      class="text-capitalize text-center white--text pa-1"
                    >
                      {{ item.status }}
                    </v-card>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <div>
                        <v-row>
                          <v-col>
                            <div class="d-flex py-4">
                              <h2 class="mr-2">{{ item.amount }}</h2>
                              <span class="overline"> {{ currency }}</span>
                            </div>
                            <div v-if="item.comment" class="mb-4">
                              <p class="font-weight-bold mb-1">
                                Comments / E-code
                              </p>
                              <p class="mb-0">{{ item.comment }}</p>
                            </div>
                            <div v-if="Array.isArray(item.images) && item.images.length">
                              <p class="font-weight-bold mb-1">Uploaded card image(s)</p>
                              <div class="d-flex">
                                <CoolLightBox
                                  :items="item.images"
                                  :index="giftcardUploadImageIndex"
                                  @close="giftcardUploadImageIndex = null"
                                >
                                  <template v-slot:close>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke-width="1.5"
                                      stroke="currentColor"
                                      class="w-6 h-6"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M6 18L18 6M6 6l12 12"
                                      />
                                    </svg>
                                  </template>
                                </CoolLightBox>
                                <div style="display: flex">
                                  <div
                                    style="
                                      width: 50px;
                                      height: 50px;
                                      margin-right: 10px;
                                      background-size: cover;
                                    "
                                    v-for="(
                                      image, imageIndex
                                    ) in item.images"
                                    :key="imageIndex"
                                    @click="giftcardUploadImageIndex = imageIndex"
                                    :style="{
                                      backgroundImage: 'url(' + image + ')'
                                    }"
                                  ></div>
                                </div>
                              </div>
                            </div>
                            <div v-if="item.status === 'declined'">
                              <p>{{ item.reason }}</p>
                              <div
                                v-if="Array.isArray(item.declineImages)"
                                class="d-flex"
                              >
                                <CoolLightBox
                                  :items="item.declineImages"
                                  :index="giftcardImageIndex"
                                  @close="giftcardImageIndex = null"
                                >
                                  <template v-slot:close>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke-width="1.5"
                                      stroke="currentColor"
                                      class="w-6 h-6"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M6 18L18 6M6 6l12 12"
                                      />
                                    </svg>
                                  </template>
                                </CoolLightBox>
                                <div style="display: flex">
                                  <div
                                    style="
                                      width: 50px;
                                      height: 50px;
                                      margin-right: 10px;
                                      background-size: cover;
                                    "
                                    v-for="(
                                      image, imageIndex
                                    ) in item.declineImages"
                                    :key="imageIndex"
                                    @click="giftcardImageIndex = imageIndex"
                                    :style="{
                                      backgroundImage: 'url(' + image + ')'
                                    }"
                                  ></div>
                                </div>
                              </div>
                              <div v-else>
                                <v-img
                                  :src="item.declineImages"
                                  width="80"
                                  height="80"
                                ></v-img>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </template>
                </v-data-table>
              </v-container>
            </v-card>
          </v-tab-item>

          <!--          Cashback-->
          <v-tab-item>
            <v-card flat :loading="cashbackLoading">
              <v-container class="py-2">
                <v-col v-if="cashbackHistory.length === 0" class="text-center">
                  <no-transaction />
                  <v-btn
                    depressed
                    class="accent darken-1 mx-auto"
                    to="/user/products"
                    >Start Transaction
                  </v-btn>
                </v-col>
                <v-data-table
                  v-else
                  :headers="headerCashback"
                  :items="cashbackHistory"
                  class="elevation-0"
                >
                  <template v-slot:[`item.date`]="{ item }">
                    <span>
                      {{ new Date(item.createdAt).toDateString() }}
                    </span>
                  </template>
                  <template v-slot:[`item.amount`]="{ item }">
                    <span>{{ Number(item.amount).toFixed(2) }}</span>
                  </template>
                  <template v-slot:[`item.source`]="{ item }">
                    <span class="capitalize"
                      >{{ item.source }}
                      <span v-if="item.category">- {{ item.category }}</span>
                    </span>
                  </template>
                  <template v-slot:[`item.type`]="{ item }">
                    <v-card
                      :color="
                        item.type == 'credit'
                          ? 'success'
                          : item.status == 'debit'
                          ? 'warning'
                          : 'error'
                      "
                      flat
                      rounded="md"
                      outlined
                      class="text-capitalize text-center white--text pa-1"
                    >
                      {{ item.type }}
                    </v-card>
                  </template>
                </v-data-table>
              </v-container>
            </v-card>
          </v-tab-item>

          <v-tab-item>
            <v-card>
              <v-container>
                <v-data-table
                  :headers="headerFundTransfer"
                  :items="fundTransfers"
                >
                  <template v-slot:[`item.date`]="{ item }">
                    {{ new Date(item.createdAt).toDateString() }}
                  </template>

                  <template v-slot:[`item.amount`]="{ item }">
                    <span>{{ item.amount }}</span>
                    <span class="overline"> {{ currency }}</span>
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    <v-card
                      :color="
                        item.status == 'approved'
                          ? 'success'
                          : item.status == 'pending' ||
                            item.status == 'processing'
                          ? 'warning'
                          : 'error'
                      "
                      flat
                      rounded="md"
                      outlined
                      class="text-capitalize text-center white--text pa-1"
                    >
                      {{ item.status }}
                    </v-card>
                  </template>

                  <template v-slot:no-data>
                    <div class="py-3 text-center">
                      <v-img
                        src="@/assets/img/undraw_empty.svg"
                        width="325"
                        class="mx-auto"
                        alt="empty"
                      />
                      <h2 class="mt-3">No previous transfer transactions</h2>
                    </div>
                  </template>
                </v-data-table>
              </v-container>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card>
              <v-container>
                <v-data-table
                  :headers="headerTokenHistory"
                  :items="tokenHistory"
                >
                  <template v-slot:[`item.date`]="{ item }">
                    {{ new Date(item.createdAt).toDateString() }}
                  </template>

                  <template v-slot:no-data>
                    <div class="py-3 text-center">
                      <v-img
                        src="@/assets/img/undraw_empty.svg"
                        width="325"
                        class="mx-auto"
                        alt="empty"
                      />
                      <h2 class="mt-3">No previous token conversion</h2>
                    </div>
                  </template>
                </v-data-table>
              </v-container>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card>
              <v-container>
                <v-data-table
                  :headers="headerTokenHistory"
                  :items="bonusHistory"
                >
                  <template v-slot:[`item.date`]="{ item }">
                    {{ new Date(item.createdAt).toDateString() }}
                  </template>

                  <template v-slot:no-data>
                    <div class="py-3 text-center">
                      <v-img
                        src="@/assets/img/undraw_empty.svg"
                        width="325"
                        class="mx-auto"
                        alt="empty"
                      />
                      <h2 class="mt-3">No previous bonus conversion</h2>
                    </div>
                  </template>
                </v-data-table>
              </v-container>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card>
              <v-container>
                <v-data-table
                  :headers="headerPromoCodes"
                  :items="promoCodeHistory"
                >
                  <template v-slot:[`item.date`]="{ item }">
                    {{ new Date(item.createdAt).toDateString() }}
                  </template>

                  <!-- <template v-slot:[`item.value`]="{ item }">
                    <p>
                      {{ item.discountValue }}
                      {{ item.discountType === 'percentage' ? '%' : '(FIXED)' }}
                    </p>
                  </template> -->

                  <template v-slot:[`item.trx`]="{ item }">
                    <span>
                      {{ item.product.name }}
                    </span>
                  </template>

                  <template v-slot:[`item.trxAmount`]="{ item }">
                    <span>
                      {{ item.trxAmount }}
                    </span>
                  </template>

                  <template v-slot:[`item.trxStatus`]="{ item }">
                    <v-card
                      :color="
                        item.transaction.status == 'approved'
                          ? 'success'
                          : item.transaction.status == 'pending'
                          ? 'warning'
                          : 'error'
                      "
                      flat
                      rounded="md"
                      outlined
                      class="text-capitalize text-center white--text pa-1"
                    >
                      {{ item.transaction.status }}
                    </v-card>
                  </template>

                  <template v-slot:no-data>
                    <div class="py-3 text-center">
                      <v-img
                        src="@/assets/img/undraw_empty.svg"
                        width="325"
                        class="mx-auto"
                        alt="empty"
                      />
                      <h2 class="mt-3">No previous bonus conversion</h2>
                    </div>
                  </template>
                </v-data-table>
              </v-container>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card>
              <v-container>
                <v-data-table :headers="headerBill" :items="historyTransaction">
                  <template v-slot:[`item.date`]="{ item }">
                    {{ new Date(item.createdAt).toDateString() }}
                  </template>

                  <template v-slot:[`item.status`]="{ item }">
                    <v-card
                      :color="
                        item.status == 'completed'
                          ? 'success'
                          : item.status == 'pending' ||
                            item.status == 'processing'
                          ? 'warning'
                          : 'error'
                      "
                      flat
                      rounded="md"
                      outlined
                      class="text-capitalize text-center white--text pa-1"
                    >
                      {{ item.status }}
                    </v-card>
                  </template>

                  <template v-slot:[`item.amount`]="{ item }">
                    <span> {{ item.currency }} {{ item.amountCharged }}</span>
                  </template>

                  <template v-slot:no-data>
                    <div class="py-3 text-center">
                      <v-img
                        src="@/assets/img/undraw_empty.svg"
                        width="325"
                        class="mx-auto"
                        alt="empty"
                      />
                      <h2 class="mt-3">No previous bonus conversion</h2>
                    </div>
                  </template>
                </v-data-table>
              </v-container>
            </v-card>
          </v-tab-item>
          <!-- Funding History -->
          <v-tab-item
            v-if="COUNTRIES.GH !== userCountry || COUNTRIES.KE !== userCountry"
          >
            <v-card flat :loading="fundingLoading">
              <v-container class="py-2">
                <v-col v-if="fundingRequest.length === 0" class="text-center">
                  <no-transaction />
                </v-col>
                <v-data-table
                  v-else
                  :headers="headerFunding"
                  :items="fundingRequest"
                  class="elevation-0"
                >
                  <template v-slot:[`item.amount`]="{ item }">
                    {{ item.currency }} {{ numberWithCommas(item.amount) }}
                  </template>
                  <template v-slot:[`item.date`]="{ item }">
                    {{ new Date(item.createdAt).toDateString() }}
                  </template>
                </v-data-table>
              </v-container>
            </v-card>
          </v-tab-item>

          <!-- Withdrawals -->
          <v-tab-item>
            <v-card flat :loading="withdrawalLoading">
              <v-container class="py-10">
                <v-col
                  v-if="withdrawalHistory.length === 0"
                  class="text-center"
                >
                  <no-transaction />
                </v-col>
                <v-data-table
                  v-else
                  :headers="headerWithdrawal"
                  :items="withdrawalHistory"
                  class="elevation-0"
                >
                  <template v-slot:[`item.amount`]="{ item }">
                    <span>{{ currency }} {{ formatFiat(item.amount) }}</span>
                  </template>
                  <template v-slot:[`item.charge`]="{ item }">
                    <span>{{ currency }} {{ formatFiat(item.charge || 0) }}</span>
                  </template>
                  <template v-slot:[`item.date`]="{ item }">
                    {{ new Date(item.createdAt).toDateString() }}
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    <v-card
                      :color="
                        item.status == 'approved'
                          ? 'success'
                          : item.status == 'pending' ||
                            item.status == 'processing'
                          ? 'warning'
                          : 'error'
                      "
                      flat
                      rounded="md"
                      outlined
                      class="text-capitalize text-center white--text pa-1"
                    >
                      {{ item.status }}
                    </v-card>
                  </template>
                </v-data-table>
              </v-container>
            </v-card>
          </v-tab-item>
          <!-- Swap History -->
          <v-tab-item>
            <v-card flat :loading="swapLoading">
              <v-container class="py-10">
                <v-col
                  v-if="swapHistoryRows.length === 0"
                  class="text-center"
                >
                  <no-transaction />
                </v-col>
                <v-data-table
                  v-else
                  :headers="headerSwapHistory"
                  :items="swapHistoryRows"
                  class="elevation-0"
                >
                  <template v-slot:[`item.from`]="{ item }">
                    <span>{{ item.fromAmount }} {{ item.fromSymbol }}</span>
                  </template>
                  <template v-slot:[`item.to`]="{ item }">
                    <span>{{ item.toAmount }} {{ item.toSymbol }}</span>
                  </template>
                  <template v-slot:[`item.date`]="{ item }">
                    {{ item.date }}
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    <v-card
                      color="success"
                      flat
                      rounded="md"
                      outlined
                      class="text-capitalize text-center white--text pa-1"
                    >
                      {{ item.status }}
                    </v-card>
                  </template>
                </v-data-table>
              </v-container>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
      <v-col cols="12" md="3">
        <v-sheet color="white" class="pa-6" rounded="lg">
          <h4 class="text-h6 mb-4">Filter</h4>
          <v-divider></v-divider>
          <v-radio-group v-model="filterBy">
            <v-sheet
              outlined
              rounded="lg"
              elevation="0"
              v-for="filterOption in filterOptions"
              :key="filterOption.value"
              class="py-3 px-4 text-left my-2"
            >
              <v-radio
                color="accent"
                :label="filterOption.title"
                :value="filterOption.value"
              ></v-radio>
            </v-sheet>
          </v-radio-group>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import noTransaction from '../../components/noTransaction.vue'
import transactionApi from '../../api/users/transactions'
import { numberWithCommas, formatFiat, truncate } from '../../utils/helpers'
import { mapState } from 'vuex'
import walletApi from '../../api/users/wallet'
import promoCodes from '../../api/promo-codes'

import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import bill from '../../api/users/bill'
import cashbackApi from '../../api/users/cashback'
import withdrawApi from '../../api/users/withdraw'
import cryptocoinApi from '../../api/users/cryptocoin'
import { COUNTRIES, getCurrencySymbol } from '../../utils/countryHelpers'
import { formatCryptoAmount } from '../../utils/cryptoHistory'

export default {
  name: 'TransactionHistory',
  components: { noTransaction, CoolLightBox },
  data: () => ({
    truncate,
    numberWithCommas,
    formatFiat,
    COUNTRIES,
    transactionTab: null,
    filterBy: 'all',
    filterOptions: [
      { title: 'All', value: 'all' },
      { title: 'Pending', value: 'pending' },
      { title: 'Approved', value: 'approved' },
      { title: 'Declined', value: 'declined' }
    ],
    giftcardHeaders: [
      {
        text: 'Trx ID',
        value: 'trx',
        sortable: false
      },
      {
        text: 'Date',
        value: 'date'
      },
      {
        text: 'Giftcard',
        value: 'image'
      },
      {
        text: 'Name',
        value: 'giftcard.name'
      },
      {
        text: 'Amount',
        value: 'amount'
      },
      {
        text: 'Status',
        value: 'status'
      },
      { text: '', value: 'data-table-expand' }
    ],
    headersAirtime: [
      {
        text: 'Date',
        value: 'date',
        align: 'start'
      },
      {
        text: 'Provider/Network',
        value: 'network'
      },
      {
        text: 'Status',
        value: 'status'
      }
    ],
    headers: [
      {
        text: 'Trx ID.',
        align: 'start',
        sortable: false,
        value: 'trx'
      },
      {
        text: 'Date',
        value: 'date'
      },
      {
        text: 'Currency',
        value: 'currency'
      },
      {
        text: 'Amount',
        value: 'amount'
      },

      {
        text: 'Rate',
        value: 'rate'
      },
      {
        text: 'Price',
        value: 'price'
      },
      {
        text: 'Status',
        value: 'status'
      },
      { text: '', value: 'data-table-expand' }
    ],
    headerFundTransfer: [
      {
        text: 'Trx ID.',
        align: 'start',
        sortable: false,
        value: 'transaction_id'
      },
      {
        text: 'Date',
        value: 'date'
      },
      {
        text: 'Transfer To',
        value: 'send_details'
      },
      {
        text: 'Amount',
        value: 'amount'
      },
      {
        text: 'Status',
        value: 'status'
      }
    ],
    headerPromoCodes: [
      {
        text: 'Date',
        value: 'date'
      },
      {
        text: 'Code Used',
        value: 'promoCode.code'
      },
      {
        text: 'Tnx Done',
        value: 'trx'
      },
      {
        text: 'Tnx Amount',
        value: 'trxAmount'
      },
      {
        text: 'Promo Code Amount',
        value: 'promoCodeAmount'
      },
      {
        text: 'Tnx Status',
        value: 'trxStatus'
      }
    ],
    headerTokenHistory: [
      {
        text: 'Token',
        align: 'start',
        sortable: false,
        value: 'amount'
      },
      {
        text: 'Date',
        value: 'date'
      },
      {
        text: 'Current Rate',
        value: 'currentRate'
      },
      {
        text: 'Description',
        value: 'description'
      }
    ],
    headerBill: [
      {
        text: 'Type',
        align: 'start',
        sortable: false,
        value: 'type'
      },
      {
        text: 'Date',
        value: 'date'
      },
      {
        text: 'Amount Charged',
        value: 'amount'
      },
      {
        text: 'Package',
        value: 'package'
      },
      {
        text: 'Provider',
        value: 'provider'
      },
      {
        text: 'Status',
        value: 'status'
      }
    ],
    headerFunding: [
      {
        text: 'Date',
        value: 'date'
      },
      {
        text: 'Amount',
        value: 'amount'
      },
      {
        text: 'Description',
        value: 'description'
      },
      {
        text: 'Reference No.',
        value: 'ref'
      }
    ],
    headerCashback: [
      {
        text: 'Date',
        value: 'date'
      },
      {
        text: 'Points',
        value: 'amount'
      },
      {
        text: 'Type',
        value: 'type'
      },
      {
        text: 'Description',
        value: 'source'
      }
    ],
    transactionSales: [],
    salesLoading: false,
    salesPage: 1,
    salesPerPage: 10,
    salesTotal: 0,
    transactionPurchase: [],
    purchaseLoading: false,
    purchasePage: 1,
    purchasePerPage: 10,
    purchaseTotal: 0,
    transactionGiftcard: [],
    giftcardLoading: false,
    giftcardPage: 1,
    giftcardPerPage: 10,
    giftcardTotal: 0,
    cashbackLoading: false,
    fundingLoading: false,
    withdrawalLoading: false,
    swapLoading: false,
    recharges: [],
    fundTransfers: [],
    tokenHistory: [],
    bonusHistory: [],
    promoCodeHistory: [],
    giftcardImageIndex: null,
    giftcardUploadImageIndex: null,
    purchaseImageIndex: null,
    salesImageIndex: null,
    historyTransaction: [],
    fundingRequest: [],
    cashbackHistory: [],
    withdrawalHistory: [],
    headerWithdrawal: [
      {
        value: 'transaction_id',
        text: 'Trnx No',
        sortable: false
      },
      {
        value: 'amount',
        text: 'Amount'
      },
      {
        value: 'method.name',
        text: 'Method'
      },
      {
        value: 'charge',
        text: 'Charge'
      },
      {
        value: 'date',
        text: 'Date'
      },
      {
        value: 'status',
        text: 'Status'
      }
    ],
    headerSwapHistory: [
      {
        text: 'Date',
        value: 'date'
      },
      {
        text: 'From',
        value: 'from',
        sortable: false
      },
      {
        text: 'To',
        value: 'to',
        sortable: false
      },
      {
        text: 'Rate',
        value: 'rate',
        sortable: false
      },
      {
        text: 'Status',
        value: 'status',
        sortable: false
      },
      {
        text: 'Reference',
        value: 'reference',
        sortable: false
      }
    ],
    swapHistoryRaw: []
  }),
  created() {
    this.getSalesTransactions()
    this.getPurchaseTransactions()
    this.getGiftcardTransactions()
    this.getFundTransfer()
    this.getPromoCodeUsage()
    this.getTokenHistory()
    this.getBonusHistory()
    this.getHistoryTransaction()
    this.getFundingHistory()
    this.getCashbackHistory()
    this.getWithdrawalHistory()
    this.getSwapHistory()
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      siteData: (state) => state.user.siteSettings
    }),
    currency() {
      return getCurrencySymbol(this.userCountry.toLocaleLowerCase())
    },
    swapHistoryRows() {
      return this.buildSwapRows(this.swapHistoryRaw)
    },
    tabList() {
      const list = [
        {
          title: 'Sales',
          index: 0
        },
        {
          title: 'Purchase',
          index: 1
        },
        {
          title: 'Giftcard',
          index: 2
        },
        {
          title: 'Cashback',
          index: 3
        },
        {
          title: 'Fund Transfer',
          index: 4
        },
        {
          title: 'Token Conversion',
          index: 5
        },
        {
          title: 'Bonus Conversion',
          index: 6
        },
        {
          title: 'Promo Code Usage',
          index: 7
        },
        {
          title: 'Bill History',
          index: 8
        },
        {
          title: 'Funding History',
          index: 9
        },
        {
          title: 'Withdrawals',
          index: 10
        },
        {
          title: 'Swap History',
          index: 11
        }
      ]

      if (
        this.userCountry === COUNTRIES.GH ||
        this.userCountry === COUNTRIES.KE
      ) {
        list.splice(1, 1)
        list.splice(8, 1)
        // list.slice(3, 1)
      }

      return list
    }
  },
  watch: {
    filterBy() {
      this.salesPage = 1
      this.getSalesTransactions()
      this.purchasePage = 1
      this.getPurchaseTransactions()
      this.giftcardPage = 1
      this.getGiftcardTransactions()
    }
  },
  methods: {
    async getPromoCodeUsage() {
      const res = await promoCodes.promoCodes().getCodeUsage({
        params: {
          limit: 0,
          populate: ['product', 'promoCode', 'user', 'transaction']
        },
        requester: 'user'
      })
      // this.promoCodeHistory = res.data.data.data
      this.promoCodeHistory = res.data.data.data.map((history) => ({
        ...history,
        trxAmount: history.originalAmount,
        promoCodeAmount: history.discountValue,
        trxDiscount: history.discountValue
      }))
    },
    // Sales tab fetches only what the current filter/page needs, instead
    // of pulling every sale down and filtering it in the browser.
    async getSalesTransactions() {
      this.salesLoading = true
      const res = await transactionApi.transactions().getSales({
        status: this.filterBy,
        page: this.salesPage,
        limit: this.salesPerPage
      })
      if (!res.error) {
        this.transactionSales = (res.data.data.data || []).map(
          (transaction) => ({
            ...transaction,
            id: transaction._id,
            transactionID: transaction._id,
            date: transaction.date_string,
            amount: {
              price: numberWithCommas(transaction.amount),
              currency:
                transaction.coin?.displaySymbol ||
                transaction.coin?.symbol ||
                ''
            },
            currency: transaction.currency
              ? transaction.currency.symbol
              : transaction.currencyCode,
            trx: transaction.trx,
            rate: {
              price: formatFiat(transaction.rate),
              currency: this.currency
            },
            price: formatFiat(transaction.main_amo),
            status: transaction.status
          })
        )
        this.salesTotal = res.data.data.meta?.total ?? this.transactionSales.length
      }
      this.salesLoading = false
    },
    onSalesPageChange(page) {
      this.salesPage = page
      this.getSalesTransactions()
    },
    onSalesPerPageChange(perPage) {
      this.salesPerPage = perPage
      this.salesPage = 1
      this.getSalesTransactions()
    },
    // Same pattern as Sales, for Purchase.
    async getPurchaseTransactions() {
      this.purchaseLoading = true
      const res = await transactionApi.transactions().getPurchases({
        status: this.filterBy,
        page: this.purchasePage,
        limit: this.purchasePerPage
      })
      if (!res.error) {
        this.transactionPurchase = (res.data.data.data || []).map(
          (transaction) => ({
            ...transaction,
            id: transaction._id,
            transactionID: transaction._id,
            date: transaction.date_string,
            currency: transaction.currency
              ? transaction.currency.name
              : transaction.currencyCode,
            trx: transaction.trx,
            amount: {
              price: numberWithCommas(transaction.amount),
              currency:
                transaction.coin?.displaySymbol ||
                transaction.coin?.symbol ||
                ''
            },
            rate: {
              price: formatFiat(transaction.rate),
              currency: this.currency
            },
            price: formatFiat(transaction.main_amo),
            status: transaction.status
          })
        )
        this.purchaseTotal =
          res.data.data.meta?.total ?? this.transactionPurchase.length
      }
      this.purchaseLoading = false
    },
    onPurchasePageChange(page) {
      this.purchasePage = page
      this.getPurchaseTransactions()
    },
    onPurchasePerPageChange(perPage) {
      this.purchasePerPage = perPage
      this.purchasePage = 1
      this.getPurchaseTransactions()
    },
    // Same pattern, for Giftcard.
    async getGiftcardTransactions() {
      this.giftcardLoading = true
      const res = await transactionApi.transactions().getGiftcards({
        status: this.filterBy,
        page: this.giftcardPage,
        limit: this.giftcardPerPage
      })
      if (!res.error) {
        this.transactionGiftcard = (res.data.data.data || []).map((trx) => ({
          ...trx,
          date: new Date(
            trx.created_at ? trx.created_at : trx.createdAt
          ).toDateString(),
          id: trx._id,
          image: trx.giftcard ? trx.giftcard.image : '',
          amount: formatFiat(trx.main_amo)
        }))
        this.giftcardTotal =
          res.data.data.meta?.total ?? this.transactionGiftcard.length
      }
      this.giftcardLoading = false
    },
    onGiftcardPageChange(page) {
      this.giftcardPage = page
      this.getGiftcardTransactions()
    },
    onGiftcardPerPageChange(perPage) {
      this.giftcardPerPage = perPage
      this.giftcardPage = 1
      this.getGiftcardTransactions()
    },
    async getFundTransfer() {
      const res = await transactionApi.transactions().getFundTransfer()
      this.fundTransfers = res.data.data.data
    },
    async getFundingHistory() {
      this.fundingLoading = true
      const res = await walletApi
        .data()
        .walletHistory({ transactionType: 'deposit', limit: 0 })
      this.fundingLoading = false
      if (res.error) return
      this.fundingRequest = res.data.data.data || []
    },
    async getWithdrawalHistory() {
      this.withdrawalLoading = true
      const res = await withdrawApi.withdraw().getAll(['user', 'wallet', 'method'])
      this.withdrawalLoading = false
      if (res.error) return
      this.withdrawalHistory = res.data.data.data || []
    },
    async getTokenHistory() {
      const res = await walletApi
        .data()
        .walletHistory({ category: 'token', limit: 0 })
      this.tokenHistory = res.data.data.data
    },
    async getBonusHistory() {
      const res = await walletApi
        .data()
        .walletHistory({ category: 'bonus', limit: 0 })
      this.bonusHistory = res.data.data.data
    },
    async getCashbackHistory() {
      this.cashbackLoading = true
      const res = await cashbackApi
        .cashbackApi()
        .getCashbackWalletHistory({ limit: 0 })
      this.cashbackHistory = res.data.data.data
      this.cashbackLoading = false
    },
    async getSwapHistory() {
      this.swapLoading = true
      const res = await cryptocoinApi.cryptoCoin().getCryptoWalletHistory(
        undefined,
        undefined,
        { category: 'swap', limit: 0, populate: 'coin' }
      )
      this.swapLoading = false
      if (res.error) return
      this.swapHistoryRaw = res.data.data.data || []
    },
    /**
     * Each swap produces two wallet-history entries sharing the same
     * reference — a debit on the source coin and a credit on the
     * destination coin. Pair them up into a single "from X to Y" row,
     * mirroring the mobile app's swap-history screen.
     */
    buildSwapRows(items) {
      const byReference = new Map()
      for (const item of items) {
        const ref = item.reference || item._id
        if (!byReference.has(ref)) byReference.set(ref, [])
        byReference.get(ref).push(item)
      }

      const rows = []
      for (const [reference, group] of byReference) {
        const debit = group.find((g) => g.type === 'debit') || group[0]
        const credit =
          group.find((g) => g.type === 'credit') || group[1] || group[0]
        if (!debit) continue

        const fromSymbol = (
          debit.coin?.displaySymbol ||
          debit.coin?.symbol ||
          '?'
        ).toUpperCase()
        const toSymbol = (
          credit?.coin?.displaySymbol ||
          credit?.coin?.symbol ||
          '?'
        ).toUpperCase()

        const fromAmount = Math.abs(debit.amount || 0)
        const toAmount = Math.abs(credit?.amount || 0)
        const rate =
          fromAmount > 0 ? (toAmount / fromAmount).toLocaleString('en-US') : '0'

        rows.push({
          id: reference,
          date: new Date(debit.createdAt).toDateString(),
          sortKey: debit.createdAt,
          fromAmount: formatCryptoAmount(fromAmount),
          fromSymbol,
          toAmount: formatCryptoAmount(toAmount),
          toSymbol,
          rate: `${rate} ${toSymbol} per ${fromSymbol}`,
          status: 'Approved',
          reference
        })
      }

      return rows.sort((a, b) => (a.sortKey < b.sortKey ? 1 : -1))
    },
    async getHistoryTransaction() {
      const res = await bill.billApi().history.getTransaction({
        status: 'completed'
      })
      this.historyTransaction = res.data.data.data.map((history) => ({
        ...history,
        type: this.formatType(history.type),
        date: new Date(history.createdAt).toDateString(),
        amount: formatFiat(history.amount)
      }))
    },
    formatType(type) {
      let t = type.replace(/-/g, ' ')
      t = t.charAt(0).toUpperCase() + t.slice(1, t.length)
      return t
    }
  }
}
</script>

<style>
.custom-tab .v-slide-group__wrapper {
  display: none !important;
}
</style>
